import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ElementRef,
  ViewChild,
} from '@angular/core';

import Map from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

import * as olProj from 'ol/proj';

import TileLayer from 'ol/layer/Tile';

import axios from 'src/app/Service/axios';

import { NotificationService } from 'src/app/Service/notification.service';

import { ActivatedRoute, Router } from '@angular/router';

import { OtherService } from 'src/app/Service/other.service';

import { MapService } from 'src/app/Service/map.service';

import { Location } from '@angular/common';

import { Options } from '@angular-slider/ngx-slider';

import Polygon from 'ol/geom/Polygon';

import Feature from 'ol/Feature';

import VectorSource from 'ol/source/Vector';

import VectorLayer from 'ol/layer/Vector';

import { Fill, Stroke, Style } from 'ol/style';

import { defaults as defaultControls, FullScreen } from 'ol/control';

import { BingMaps, XYZ } from 'ol/source';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import * as XLSX from 'xlsx';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

declare let $: any;
@Component({

  selector: 'Route',

  templateUrl: './routecomponent.html',

})

export class RouteComponent implements OnInit {

  map: any = {};

  fullRoute: any;

  Id: number = 0;

  interval: any;

  index: number = 1;

  showArrowbtn: boolean = true;

  animatemod: boolean = false;

  speed: number = 500;

  routeLenght: number = 0;

  dataAz: any;

  dataTa: any;

  polygonId: any;

  stop: boolean = true;

  lastindex: any;

  minindex: number = 0;

  mini: number = 0;

  polyganData: any;

  exportPdf: boolean = false;

  source: any;

  vector: any;

  access: any;

  zones: any = [];

  layers: any = [];

  fTotalDistance: any;

  strTotalTime: any;

  mapSatelait: boolean = false;

  routeData: any;

  isSort: boolean = false;

  isAnimationPause: boolean = false;

  bTankerRoute: boolean = false;

  FuelTanker: boolean = false;

  showCustom_Map: boolean = false;

  value: number = 0;

  highValue: number = 60;

  options: Options = {

    floor: 0,

    ceil: 200,

  };

  startTime!: number;

  carSpeed!: number;

  carName!: string;

  carPelak!: string;

  tankerHeight: number = 0;

  tankerFill: number = 0;

  tankerVolume: number = 0;

  fullDateTime: string;

  mdl_Map: FormGroup = this.FormBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  })

  mdl_Line: FormGroup = this.FormBuilder.group({

    drawLine: new FormControl(false),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

  })

  mdl_Date: FormGroup = this.FormBuilder.group({

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

  })

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(
    private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private route: ActivatedRoute,
    private mapService: MapService,
    private _location: Location,
    private gurdService: GurdServiceService,
    private FormBuilder: FormBuilder
  ) { }

  ngOnInit(): void {

    this.access = JSON.parse(this.gurdService.decrypt(localStorage.getItem('menu') as string)!);

    setTimeout(() => {

      this.newOpenMap();

      this.route.url.subscribe((segment) => {

        if (segment[0].path == 'tanker-route') this.bTankerRoute = true;

        this.route.params.subscribe((params) => {

          this.Id = params['id'];

          this.polygonId = params['polygon'];

        });

      })

      if (this.polygonId) {

        this.getRouteInPolygan().then(() => {

          this.fitMap(this.polyganData.lstPoints);

        });

        this.drawPolygan().then(() => {

          this.fitMap(this.polyganData.lstPoints);

        });

      }

      else this.getRoute(this.gurdService.decrypt(window.localStorage.getItem('reportStime')!), this.gurdService.decrypt(window.localStorage.getItem('reportEtime')!));

    }, 1000);

    setTimeout(() => {

      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }
        setTimeout(() => {
          var el = this.mapService.mapPointerMove(
            this.map.getEventPixel(e.originalEvent),
            this.map
          );
          this.showData(el);
        }, 50);
      });

      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });

      if (localStorage.getItem('zone1') && localStorage.getItem('zone2')) {
        this.zones[0] = this.gurdService.decrypt(JSON.parse(localStorage.getItem('zone1')!))
        this.zones[1] = this.gurdService.decrypt(JSON.parse(localStorage.getItem('zone2')!))
        this.drawFence(this.zones[0]);
        this.drawFence(this.zones[1]);
        localStorage.removeItem('zone1');
        localStorage.removeItem('zone2');
      }

      if (localStorage.getItem('inspectionZones')) {
        let areas: any = this.gurdService.decrypt(JSON.parse(localStorage.getItem('inspectionZones')!));
        areas.forEach((element: any) => {
          this.drawFence(element)
        });
      }

    }, 1500);

  }

  async recallDistance() {
    $.confirm({
      title: `آیا از محاسبه نرم افزاری فاصله ها اطمینان دارید ؟`,
      content: 'این عملیات ممکن است تا یک دقیقه طول بکشد',
      type: 'red',
      buttons: {
        ok: {
          text: "تایید",
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            let model = {
              'iSystemUser': this.gurdService.decrypt(localStorage.getItem('ID')!),
              'strSession': this.gurdService.decrypt(localStorage.getItem('Session')!),
              'strUnitID': this.gurdService.decrypt(localStorage.getItem('UnitID')!),
              'strSDate': this.gurdService.decrypt(localStorage.getItem('RouteDate')!),
              'strEDate': this.gurdService.decrypt(localStorage.getItem('RouteDate')!),
            }
            const resp = await axios.post(`ReCalDistance4ADate`, model);
            let res = JSON.parse((await axios.post(`ReCalDistance4ADate`, model)).data.toString());
            var model2 = {
              strUnitID: this.Id,
              iGeoFance: this.polygonId,
              strSDate: this.gurdService.decrypt(window.localStorage.getItem('RouteDate')!),
              strEDate: this.gurdService.decrypt(window.localStorage.getItem('RouteDate')!),
              strSTime: "00:00",
              strETime: "23:59",
            };
            const resp2 = await axios.post(`GetDistanceAndTime`, model2);
            let parse = JSON.parse(resp2.data);
            this.strTotalTime = parse[0].strTotalTime;
            this.fTotalDistance = parse[0].fTotalDistance;
            this.notifyService.showSuccess('به روز رسانی با موفقیت انجام شد')
          }
        },
        cancel: {
          text: "لغو",
        }
      }
    });



  }

  reload() {
    if (this.polygonId) {
      this.getRouteInPolygan().then(() => {
        this.fitMap(this.polyganData.lstPoints);

      });
      this.drawPolygan().then(() => {
        this.fitMap(this.polyganData.lstPoints);
      });
    } else {
      this.getRoute(this.gurdService.decrypt(window.localStorage.getItem('reportStime')!), this.gurdService.decrypt(window.localStorage.getItem('reportEtime')!));
    }
  }

  newOpenMap() {

    this.source = new VectorSource({ wrapX: false });

    this.vector = new VectorLayer({
      source: this.source,
    });


    if (this.bOfflineMap) {

      this.layers.push(

        new TileLayer({

          source: new XYZ({

            // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

            url: this.strMapUrl,

            attributions: 'Map data © RayanAndishehNasr' // 

          }),

        })

      );

    }

    else {

      const styles = [

        'AerialWithLabelsOnDemand',

      ];

      let i, ii;

      for (i = 0, ii = styles.length; i < ii; ++i) {

        this.layers.push(

          new TileLayer({

            visible: false,

            preload: Infinity,

            source: new BingMaps({

              // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

              imagerySet: styles[i],

            }),

          }),

        );
      }

      this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


    }

    this.map = new Map({
      controls: defaultControls().extend([new FullScreen()]),
      layers: this.layers,
      target: 'test',
      view: new View({
        center: olProj.fromLonLat([51.3833554, 35.6770113]),
        zoom: 13,
      }),
    });

  }

  showArrow() {

    //Craete Marker

    this.fullRoute.forEach((element: any, index: number) => {

      if (index % 2 === 0) {

        if (this.fullRoute[index].fLon != 0 && this.fullRoute[index].fLat != 0) {

          var marker = this.mapService.craeteArrow(

            [this.fullRoute[index].fLon, this.fullRoute[index].fLat],

            '../../../assets/Img/16.png',

            `Arrow`,

            `ArrowName`,

            {
              html: `
              
              <span class="text-success">زمان : ${this.fullRoute[index].strTime}</span>

              <br />

              <span class="text-danger">سرعت : ${this.fullRoute[index].iSpeed}</span>

              `,
            },

            this.fullRoute[index].iAngle

          );

          this.map.addLayer(marker);

        }

      }

      this.showArrowbtn = false;

    });

  }

  RemoveArrow() {

    this.mapService.removeMarkerById_New('Arrow', this.map);

    this.showArrowbtn = true;

  }

  getRouteInPolygan = async () => {
    var model = {
      strUnitID: this.Id,
      iGeoFance: this.polygonId,
      strDate: this.gurdService.decrypt(window.localStorage.getItem('RouteDate')!),
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    };
    const resp = await axios.post(`GetAllMobileHistoryInGeoFence`, model);
    if (resp.data.length < 1) {
      this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');
    }
    if (resp.data == null) {
      this.notifyService.showError('بروز خطا در سامانه');
      return;
    } else {
      this.mapService.drawRouteFull('fullRoute', this.map, resp.data, 'Hello');
      this.fitMap(resp.data);
      this.fullRoute = resp.data;
      this.routeLenght = this.fullRoute.length;
      this.lastindex = this.fullRoute.length;
      this.dataAz = this.fullRoute[0].strTime;
      this.dataTa = this.fullRoute[this.routeLenght - 1].strTime;
      this.options.ceil = this.routeLenght - 1;
      this.highValue = this.routeLenght - 1;
    }
    var model2 = {
      strUnitID: this.Id,
      iGeoFance: this.polygonId,
      strSDate: this.gurdService.decrypt(window.localStorage.getItem('RouteDate')!),
      strEDate: this.gurdService.decrypt(window.localStorage.getItem('RouteDate')!),
      strSTime: "00:00",
      strETime: "23:59",
    };
    const resp2 = await axios.post(`GetDistanceAndTime`, model2);
    let parse = JSON.parse(resp2.data);

    this.strTotalTime = parse[0].strTotalTime;

    this.fTotalDistance = parse[0].fTotalDistance;

    this.carName = this.gurdService.decrypt(window.localStorage.getItem('carName')!);

    this.carPelak = this.gurdService.decrypt(window.localStorage.getItem('plate')!);
  }

  getRoute = async (STime: any, ETime: any) => {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.Id.toString().includes('!') ? this.Id.toString().replace(/!/g, '') : this.Id,

      strDate: this.gurdService.decrypt(window.localStorage.getItem('RouteDate')!),

      strSDate: this.gurdService.decrypt(window.localStorage.getItem('RouteDate')!),

      strEDate: this.gurdService.decrypt(window.localStorage.getItem('RouteDate')!),

      strSTime: STime,

      strETime: ETime,

    };

    this.mdl_Date.patchValue({

      strSDate: this.gurdService.decrypt(window.localStorage.getItem('RouteDate')!),

      strEDate: this.gurdService.decrypt(window.localStorage.getItem('RouteDate')!),

    }, { emitEvent: false })

    this.otherService.Showspinner();

    // this.FuelTanker = true;

    let url = this.bTankerRoute ? 'Tanker_GetAllMobileHistory' : this.Id.toString().includes('!') ? 'Tanker_Discharge_Route' : 'GetAllMobileHistory';

    if (this.Id.toString().includes('*')) {

      url = 'FuelTanker_GetAllMobileHistory';

      model.strSDate = this.gurdService.decrypt(window.localStorage.getItem('RouteSDate')!)

      model.strEDate = this.gurdService.decrypt(window.localStorage.getItem('RouteEDate')!)

      this.mdl_Line.patchValue({

        strSDate: model.strSDate,

        strEDate: model.strEDate,

      })

      model.strUnitID = this.Id.toString().replace(/\*/g, '')

      this.FuelTanker = true;

      this.bTankerRoute = false;

    }

    const resp = await axios.post(url, model);

    this.otherService.nonespinner();

    if (resp.data.length < 1 || resp.data == "[]") return this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');

    if (resp.data == null) return this.notifyService.showError('بروز خطا در سامانه');

    else {

      if (this.Id.toString().includes('!') || this.Id.toString().includes('*')) {

        let res = JSON.parse(resp.data);

        this.routeData = res;

      }

      else {

        if (this.bTankerRoute || this.FuelTanker) {

          let res = JSON.parse(resp.data);

          this.routeData = res;

        }

        if (!this.bTankerRoute && !this.FuelTanker) {

          this.routeData = resp.data;

          // console.log(resp.data)

        }


      }

      // console.log(this.routeData)

      this.mapService.drawRouteFull('fullRoute', this.map, this.routeData, 'Hello');

      this.fitMap(this.routeData);

      this.fullRoute = this.routeData;

      this.routeLenght = this.fullRoute.length;

      this.lastindex = this.fullRoute.length;

      this.dataAz = this.fullRoute[0].strTime;

      this.dataTa = this.fullRoute[this.routeLenght - 1].strTime;

      this.options.ceil = this.routeLenght - 1;

      this.highValue = this.routeLenght - 1;

    }

    const resp2 = await axios.post(`GetDistanceAndTime`, model);

    let parse = JSON.parse(resp2.data);

    this.strTotalTime = parse[0].strTotalTime;

    this.fTotalDistance = parse[0].fTotalDistance;

    this.carName = this.gurdService.decrypt(window.localStorage.getItem('carName')!);

    this.carPelak = this.gurdService.decrypt(window.localStorage.getItem('plate')!);

  }

  formatted_pelak(strVehicle: any) {

    if (!strVehicle) return;

    if (strVehicle?.includes(',')) {

      return (`ایران ${strVehicle.split(',')[4]} | ${strVehicle.split(',')[2]} ${strVehicle.split(',')[1]} ${strVehicle.split(',')[0]}`)

    }

    else {

      return (`ایران ${strVehicle.split(' ')[4]} | ${strVehicle.split(' ')[2]} ${strVehicle.split(' ')[1]} ${strVehicle.split(' ')[0]}`)


    }

  }

  changeTail() {


    if (this.mapSatelait == false) {

      this.layers[1].setVisible(false);

      this.layers[0].setVisible(true);
    }
    else {
      this.layers[0].setVisible(false);

      this.layers[1].setVisible(true);
    }
    this.mapSatelait = !this.mapSatelait;

  }

  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        tooltip
          .attr(
            'data-bs-original-title',
            item.featureLayer.feature.get('data').html
          )
          .tooltip('show');
      }
    } else {
      tooltip.tooltip('hide');
    }
  }

  fitMap(data?: any) {

    if (data == null) {

      data = this.fullRoute;

    }

    if (data.length > 1) {
      var maxLatitude = Math.max.apply(
        Math,
        data.map(function (o: any) {
          return o.fLat;
        })
      );
      var maxLongitude = Math.max.apply(
        Math,
        data.map(function (o: any) {
          return o.fLon;
        })
      );
      var minLatitude = Math.min.apply(
        Math,
        data.map(function (o: any) {
          return o.fLat;
        })
      );
      var minLongitude = Math.min.apply(
        Math,
        data.map(function (o: any) {
          return o.fLon;
        })
      );

      var view = this.map.getView();

      var transformedStart = this.mapService.transformCoordinates2([
        maxLongitude,
        maxLatitude,
      ]);
      var transformedEnd = this.mapService.transformCoordinates2([
        minLongitude,
        minLatitude,
      ]);

      var source = [
        Math.min(transformedStart[0], transformedEnd[0]) - 2000,
        Math.min(transformedStart[1], transformedEnd[1]) - 2000,
        Math.max(transformedStart[0], transformedEnd[0]) + 2000,
        Math.max(transformedStart[1], transformedEnd[1]) + 2000,
      ];
      view.fit(source);
    }
  }

  animate(start: number, last: number) {

    this.mapService.removeMarkerById('fullRoute', this.map);

    this.mapService.removeMarkerById('fullRoute_start', this.map);

    this.mapService.removeMarkerById('fullRoute_end', this.map);

    this.mapService.removeLayerByName('ArrowName', this.map);

    this.mapService.removeLayerByName('polygon', this.map);

    this.animatemod = true;

    if (this.zones[0] && this.zones[1]) {

      this.drawFence(this.zones[0]);

      this.drawFence(this.zones[1]);
    }

    if (localStorage.getItem('inspectionZones')) {

      let zoneArray: any = this.gurdService.decrypt(JSON.parse(localStorage.getItem('inspectionZones')!));

      zoneArray.forEach((element: any) => {

        this.drawFence(element)

      });

    }

    ///interval

    this.interval = setInterval(async () => {

      this.index = this.index + 1;

      var array = this.fullRoute.slice(start, this.index);

      this.mapService.removeLayerByName('route_start', this.map);

      this.mapService.removeLayerByName('route_end', this.map);

      this.mapService.removeLayerByName('route_point', this.map);

      this.mapService.removeLayerByName('route_line', this.map);

      this.mapService.removeLayerByName('ArrowName', this.map);

      this.mapService.drawRouteAnimate('AnimatRoute', this.map, array, 'Hello', false, false, this.mdl_Line.get('drawLine')?.value);

      array.forEach((element: any, index: number) => {

        if (index % 2 === 0) {

          if (index > 1) {

            if (array[index - 1].fLon != 0 && array[index - 1].fLat != 0) {

              this.startTime = array[index - 1].strTime;

              this.carSpeed = array[index - 1].iSpeed;

              this.tankerHeight = array[index - 1].iHeightPercentage;

              this.tankerFill = array[index - 1].iFillPercentage;

              this.fullDateTime = array[index - 1].strTime + ' - ' + array[index - 1].strDate;

              this.tankerVolume = array[index - 1].fVolume;

              var marker = this.mapService.craeteArrow([array[index - 1].fLon, array[index - 1].fLat],

                '../../../assets/Img/162.png',

                `Arrow`,

                `ArrowName`,

                {
                  html: `
                  
                 <span class="text-success"> زمان : ${array[index - 1].strTime}</span>

                 <br />

                 <span class="text-danger"> سرعت : ${array[index - 1].iSpeed}</span>

                 `,
                },

                array[index - 1].iAngle, this.mdl_Line.get('drawLine')?.value

              );

              if (this.mdl_Line.get('drawLine')?.value) {

                this.map.addLayer(marker);

              }

            }

          }


        }

        this.showArrowbtn = false;

      });

      setTimeout(() => {

        var coordinates = olProj.transform(

          [array[array.length - 1].fLon, array[array.length - 1].fLat],

          'EPSG:4326',

          'EPSG:3857'

        );

        var el = this.mapService.mapPointerMove(

          this.map.getPixelFromCoordinate(coordinates),

          this.map

        );

        this.showData(el);

      }, 190);


      if (this.index == this.fullRoute.length || this.lastindex < this.index) {

        clearInterval(this.interval);

        this.index = 1;
      }

    }, this.speed);

  }

  replay() {
    this.mapService.removeLayerByName('route_start', this.map);
    this.mapService.removeLayerByName('route_end', this.map);
    this.mapService.removeLayerByName('route_point', this.map);
    this.mapService.removeLayerByName('route_line', this.map);
    this.mapService.removeLayerByName('ArrowName', this.map);
    this.index = this.minindex;
    clearInterval(this.interval);

    this.animate(this.minindex, this.lastindex);
    this.stop = !this.stop;
  }

  speedChange(e: any) {

    this.isAnimationPause = false;

    this.speed = e.target.value * 300;

    clearInterval(this.interval);

    this.animate(this.minindex, this.lastindex);

  }

  drawPolygan = async () => {

    if (!this.polyganData) {
      var model = {
        iGeoFence: this.polygonId,

        strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      };
      const resp = await axios.post(`Radyab_GeoAFence`, model);
      //var data=resp.data;
      this.polyganData = JSON.parse(resp.data);
    }


    var ring = [];
    if (this.polyganData.length != 0) {
      var loc = this.polyganData.lstPoints;
      for (let index = 0; index < loc.length; index++) {
        ring.push([loc[index].fLon, loc[index].fLat]);
      }
      var polygon = new Polygon([ring]);
      polygon.transform('EPSG:4326', 'EPSG:3857');
      var feature = new Feature(polygon);
      var vectorSource = new VectorSource();
      vectorSource.addFeature(feature);
      var vectorLayer = new VectorLayer({
        source: vectorSource,
        name: 'polygon',
        style: new Style({
          stroke: new Stroke({
            color: 'red',
            width: 4,
            lineDash: [10, 20, 10, 20]
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0)'
          })
        }),
      } as any);
      this.map.addLayer(vectorLayer);


    }
  }

  stopAnimate() {

    this.mapService.removeLayerByName('route_start', this.map);

    this.mapService.removeLayerByName('route_end', this.map);

    this.mapService.removeLayerByName('route_point', this.map);

    this.mapService.removeLayerByName('route_line', this.map);

    this.mapService.removeLayerByName('ArrowName', this.map);

    if (this.zones[0] && this.zones[0]) {

      this.drawFence(this.zones[0]);

      this.drawFence(this.zones[1]);
    }

    if (localStorage.getItem('inspectionZones')) {

      let zoneArray: any = this.gurdService.decrypt(JSON.parse(localStorage.getItem('inspectionZones')!));

      zoneArray.forEach((element: any) => {

        this.drawFence(element)

      });

    }

    if (this.polygonId) {

      this.getRouteInPolygan().then(() => {

        this.fitMap(this.polyganData.lstPoints);

      })

      this.drawPolygan().then(() => {

        this.fitMap(this.polyganData.lstPoints);

      })

    }

    else {

      this.getRoute(this.gurdService.decrypt(window.localStorage.getItem('reportStime')!),

        this.gurdService.decrypt(window.localStorage.getItem('reportEtime')!));
    }

    this.index = 1;

    clearInterval(this.interval);

    this.animatemod = !this.animatemod;

    this.lastindex = null;

    this.minindex = 0;

    this.showArrowbtn = !this.showArrowbtn;

    this.value = 0;

    this.speed = 500;

    this.isAnimationPause = false;


  }

  PauseAnimate() {

    this.isAnimationPause = true;

    clearInterval(this.interval);

  }

  ResumeAnimate() {

    this.isAnimationPause = false;

    this.animate(this.minindex, this.lastindex);

  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    var tooltip = $('#map_tooltip');
    tooltip.tooltip('hide');
    window.localStorage.removeItem('RouteDate');
  }

  goBack() {
    this._location.back();
  }

  ch(e: any) {

    this.dataAz = this.fullRoute[e].strTime;
    this.mini = e;
  }

  ch2(e: any) {
    this.dataTa = this.fullRoute[e].strTime;
    if (e != 0 || e != this.routeLenght - 1) {
      this.stop = false;
      this.lastindex = e;
      this.minindex = this.mini;
    }
  }

  guid() {
    this.otherService.guid(1);
  }

  exportPdfMap() {
    this.exportPdf = true;
    this.mapService.getPdf(this.map);
    setTimeout(() => {
      this.exportPdf = false;
    }, 2000);

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, "info.xlsx");
  }

  sortTime() {
    this.isSort = !this.isSort;
    this.routeData.sort((a: any, b: any) => {
      var splita = a.strTime.split(":");
      var splitb = b.strTime.split(":");
      if (this.isSort) {
        if (parseInt(splita[0]) > parseInt(splitb[0])) return 1;
        if (parseInt(splita[0]) < parseInt(splitb[0])) return -1;
        if (parseInt(splita[1]) > parseInt(splitb[1])) return 1;
        if (parseInt(splita[1]) < parseInt(splitb[1])) return -1;
        if (parseInt(splita[2]) > parseInt(splitb[2])) return 1;
        if (parseInt(splita[2]) < parseInt(splitb[2])) return -1;
        return 0;
      }
      else {
        this.isSort = false;
        if (parseInt(splita[0]) < parseInt(splitb[0])) return 1;
        if (parseInt(splita[0]) > parseInt(splitb[0])) return -1;
        if (parseInt(splita[1]) < parseInt(splitb[1])) return 1;
        if (parseInt(splita[1]) > parseInt(splitb[1])) return -1;
        if (parseInt(splita[2]) < parseInt(splitb[2])) return 1;
        if (parseInt(splita[2]) > parseInt(splitb[2])) return -1;
        return 0;

      }



    });
  }

  drawFence(data: any) {
    var ring = [];
    if (data.length != 0) {
      var loc = data.lstPoints;
      for (let index = 0; index < loc.length; index++) {
        ring.push([loc[index].fLon, loc[index].fLat]);
      }
      var polygon = new Polygon([ring]);
      polygon.transform('EPSG:4326', 'EPSG:3857');
      var feature = new Feature(polygon);
      var vectorSource = new VectorSource();
      vectorSource.addFeature(feature);
      var vectorLayer = new VectorLayer({
        source: vectorSource,
        name: 'polygon',
        style: new Style({
          stroke: new Stroke({
            color: 'rgba(242, 10, 10, 0.5)',
            width: 4,

          }),
          fill: new Fill({
            color: 'rgba(242, 10, 10, 0.2)'
          })
        }),
      } as any);
      this.map.addLayer(vectorLayer);
    }
  }

  open_Map(item) {

    this.mdl_Map.patchValue({

      strAddress: '',

      fLon: item.fLon,

      fLat: item.fLat,

      strSource: ''

    })

    this.showCustom_Map = true;


  }

  onSelectDate(event: { gregorian: string, shamsi: string, timestamp: number }) {

    window.localStorage.setItem("RouteDate", this.gurdService.encrypt(event.shamsi));

    window.localStorage.setItem("RouteSDate", this.gurdService.encrypt(event.shamsi));

    window.localStorage.setItem("RouteEDate", this.gurdService.encrypt(event.shamsi));

    window.location.reload();

  }

}

